import { Calendar, MapPin, Clock, ArrowRight } from 'lucide-react';

const Events = () => {
  const upcomingEvents = [
    {
      title: "ONE 2 KA FOUR 2026",
      date: "June 29, 30 and July 1st, 2026",
      time: "9:00 AM - 6:00 PM",
      location: "Christ University Campus View",
      description: "The ultimate barter trading challenge - powered by perfectly good.",
      image: "https://customer-assets.emergentagent.com/job_karobar-hub/artifacts/dn6vxja8_image.png",
      type: "upcoming"
    },
    {
      title: "Venture Vault 2026",
      date: "September 2026",
      time: "9:00 AM - 4:00 PM",
      location: "Christ University Main Auditorium",
      description: "Ultimate speed case study challenge - test your business acumen under pressure.",
      image: "https://images.unsplash.com/photo-1556761175-b413da4baf72?q=80&w=2074",
      type: "upcoming"
    },
    {
      title: "InternSteller",
      date: "November 2026",
      time: "9:00 AM - 4:00 PM",
      location: "Christ University KE Auditorium",
      description: "Internship drive and workshop for students - connect with top companies and enhance your professional skills.",
      image: "https://images.unsplash.com/photo-1559136555-9303baea8ebd?q=80&w=2070",
      type: "upcoming"
    },
    {
      title: "Baazigar 2027",
      date: "February 2027",
      time: "9:00 AM - 4:00 PM",
      location: "Christ University Main Auditorium",
      description: "Ultimate startup challenge - pitch your venture, compete with the best, and win funding opportunities.",
      image: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?q=80&w=2070",
      type: "upcoming"
    }
  ];

  const pastEvents = [
    {
      title: "Baazigar 2026",
      date: "February 2026",
      location: "Christ University Main Auditorium",
      description: "Ultimate startup challenge featuring pitch competitions, investor networking, and entrepreneurial excellence.",
      image: "https://customer-assets.emergentagent.com/job_karobar-hub/artifacts/27z1thzy_image.png",
      attendees: "250+"
    },
    {
      title: "Brain Brew",
      date: "November 2025",
      location: "Christ University Campus",
      description: "TED talk by industry leaders - shaping the future of entrepreneurship with inspiring stories and insights.",
      image: "https://customer-assets.emergentagent.com/job_karobar-hub/artifacts/a91yae9q_image.png",
      attendees: "350+"
    },
    {
      title: "Venture Vault 2025",
      date: "September 2025",
      location: "Christ University Main Auditorium",
      description: "Ultimate case study competition where teams solved real-world business challenges under time pressure.",
      image: "https://customer-assets.emergentagent.com/job_karobar-hub/artifacts/sfnobmpw_image.png",
      attendees: "200+"
    }
  ];

  return (
    <div className="pt-20" data-testid="events-page">
      <section className="section-padding bg-gradient-to-b from-black to-[#121212]">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <p className="text-xs font-bold tracking-[0.2em] uppercase text-gold-500 mb-4">EXPERIENCES THAT MATTER</p>
            <h1 className="text-5xl sm:text-6xl md:text-7xl font-black tracking-tighter uppercase mb-6" style={{ fontFamily: 'Open Sans' }}>EVENTS</h1>
            <p className="text-gray-400 text-lg max-w-3xl mx-auto">From workshops to pitch competitions, we create opportunities for entrepreneurs to learn, network, and grow.</p>
          </div>

          <div className="mb-20">
            <h2 className="text-3xl font-black mb-8 text-gold-500" style={{ fontFamily: 'Open Sans' }}>UPCOMING EVENTS</h2>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {upcomingEvents.map((event, index) => (
                <div key={index} className="glass-card overflow-hidden group" data-testid={`upcoming-event-card-${index}`}>
                  <div className="relative h-64 overflow-hidden">
                    <img src={event.image} alt={event.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent"></div>
                  </div>
                  <div className="p-8">
                    <h3 className="text-2xl font-black mb-4" style={{ fontFamily: 'Open Sans' }}>{event.title}</h3>
                    <div className="space-y-3 mb-6">
                      <div className="flex items-center space-x-3 text-gray-400">
                        <Calendar size={18} className="text-gold-500" />
                        <span>{event.date}</span>
                      </div>
                      <div className="flex items-center space-x-3 text-gray-400">
                        <Clock size={18} className="text-gold-500" />
                        <span>{event.time}</span>
                      </div>
                      <div className="flex items-center space-x-3 text-gray-400">
                        <MapPin size={18} className="text-gold-500" />
                        <span>{event.location}</span>
                      </div>
                    </div>
                    <p className="text-gray-400 mb-6 leading-relaxed">{event.description}</p>
                    <button className="btn-primary flex items-center space-x-2" data-testid={`register-event-button-${index}`}>
                      <span>REGISTER NOW</span>
                      <ArrowRight size={18} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h2 className="text-3xl font-black mb-8" style={{ fontFamily: 'Open Sans' }}>PAST EVENTS</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {pastEvents.map((event, index) => (
                <div key={index} className="glass-card overflow-hidden group" data-testid={`past-event-card-${index}`}>
                  <div className="relative h-48 overflow-hidden">
                    <img src={event.image} alt={event.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                    {event.attendees && (
                      <div className="absolute top-4 right-4 bg-gold-500 text-black px-3 py-1 text-xs font-bold">
                        {event.attendees} ATTENDEES
                      </div>
                    )}
                  </div>
                  <div className="p-6">
                    <h3 className="text-lg font-black mb-2" style={{ fontFamily: 'Open Sans' }}>{event.title}</h3>
                    <div className="flex items-center space-x-2 text-sm text-gold-500 mb-3">
                      <Calendar size={14} />
                      <span>{event.date}</span>
                    </div>
                    <p className="text-gray-400 text-sm leading-relaxed">{event.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Events;